<template>
  <div>
    <header-applis titre="Connaître votre projet" sous-titre="Vous êtes agent public (fonctionnaires et contractuels)" index-progression-courante="1"/>
    <div class="wrapper__content">
      <ul>
        <li>
          <p>Agent de la Fonction Publique d’État, Fonction Publique Territoriale, Fonction Publique Hospitalière :</p>
          <ul>
            <li>pour échanger et avancer sur votre projet, vous pouvez vous renseigner auprès de votre référent formation ou de votre référent en ressources humaines qui vous
              indiquera la démarche à suivre.
            </li>
          </ul>
        </li>
        <li>
          <p>Une fois votre orientation finalisée, nous vous invitons à reprendre la démarche engagée, nous pourrons alors donner suite à votre demande.</p>
        </li>
      </ul>
      <envoyer-recapitulatif/>
    </div>
    <footer-applis ecran-precedent="choixstatut"/>
  </div>
</template>

<script>
import EnvoyerRecapitulatif from '../../components/EnvoyerRecapitulatif';
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'agentpublic',
  components: {
    FooterApplis,
    HeaderApplis,
    EnvoyerRecapitulatif
  }
}
</script>

<style scoped>
input[type="text"] {
  width: 40%
}
</style>
